import { render, staticRenderFns } from "./FloatingBox.vue?vue&type=template&id=02803494&scoped=true"
import script from "./FloatingBox.vue?vue&type=script&lang=ts"
export * from "./FloatingBox.vue?vue&type=script&lang=ts"
import style0 from "./FloatingBox.vue?vue&type=style&index=0&id=02803494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02803494",
  null
  
)

export default component.exports